// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: 43COgONOe_
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicMapImage.module.css"; // plasmic-import: 43COgONOe_/css
import images2FdubaiPngChihQbGd6TnF from "./images/images2FdubaiPng.png"; // plasmic-import: chihQBGd6tnF/picture

createPlasmicElementProxy;

export const PlasmicMapImage__VariantProps = new Array();

export const PlasmicMapImage__ArgProps = new Array("cityImage");

const $$ = {};

function PlasmicMapImage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          cityImage: {
            src: images2FdubaiPngChihQbGd6TnF,
            fullWidth: 1100,
            fullHeight: 733,
            aspectRatio: undefined
          }
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <PlasmicImg__
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      alt={""}
      className={classNames(
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
      displayHeight={"100%"}
      displayMaxHeight={"none"}
      displayMaxWidth={"100%"}
      displayMinHeight={"0"}
      displayMinWidth={"0"}
      displayWidth={"100%"}
      loading={"lazy"}
      src={args.cityImage}
    />
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMapImage__ArgProps,
          internalVariantPropNames: PlasmicMapImage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMapImage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMapImage";
  } else {
    func.displayName = `PlasmicMapImage.${nodeName}`;
  }
  return func;
}

export const PlasmicMapImage = Object.assign(
  // Top-level PlasmicMapImage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicMapImage
    internalVariantProps: PlasmicMapImage__VariantProps,
    internalArgProps: PlasmicMapImage__ArgProps
  }
);

export default PlasmicMapImage;
/* prettier-ignore-end */
